import * as Sentry from '@sentry/react';

/**
 * 오류 모니터링(Sentry) — **개인정보를 보내지 않는 것이 이 파일의 존재 이유**.
 *
 * 기본값만 두면 IP·쿠키·입력값·URL 쿼리까지 함께 나간다. 우리는 개인정보 미수집이
 * 원칙이므로(CLAUDE.md §5) 전부 잘라내고 "무엇이 어디서 터졌는지"만 남긴다.
 * 개인정보 처리방침 §6에 처리위탁으로 명시되어 있다.
 *
 * DSN이 없으면 초기화하지 않는다 — 로컬·프리뷰에서 실수로 이벤트가 쌓이지 않게.
 * 값은 빌드 시 주입되는 공개 값이라 시크릿이 아니다 (DSN은 원래 공개되도록 설계됨).
 */

const DSN = import.meta.env.VITE_SENTRY_DSN;

/** 성능 추적 표본 비율 — 무료 티어를 아끼려면 낮게 */
const TRACES_SAMPLE_RATE = 0.05;

/**
 * 사용자가 손댈 수 없는데 반복해서 올라오는 잡음.
 * 확장 프로그램·번역기·크롤러가 만드는 것들이라 우리 코드와 무관하다.
 */
const IGNORED = [
  /ResizeObserver loop/i,
  /Non-Error promise rejection captured/i,
  /Failed to fetch dynamically imported module/i, // 배포 직후 구버전 청크 요청
];

export function initErrorMonitoring(): void {
  if (!DSN) return;
  Sentry.init({
    dsn: DSN,
    // IP·쿠키 등 자동 수집 끄기 (기본값이지만 의도를 드러내기 위해 명시)
    sendDefaultPii: false,
    tracesSampleRate: TRACES_SAMPLE_RATE,
    ignoreErrors: IGNORED,
    /**
     * 마지막 방어선 — SDK가 무엇을 담았든 여기서 걷어낸다.
     * 쿼리스트링에는 초대코드·공유 ID가 붙을 수 있어 경로만 남긴다.
     */
    beforeSend(event) {
      delete event.user;
      if (event.request?.url) event.request.url = event.request.url.split('?')[0];
      delete event.request?.cookies;
      delete event.request?.headers;
      return event;
    },
    /** 사용자가 무엇을 입력했는지는 남기지 않는다 */
    beforeBreadcrumb(crumb) {
      if (crumb.category === 'ui.input') return null;
      return crumb;
    },
  });
}
